import { useContext } from "react";
import { FileTypes, ProductLine, ROType } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";
import RetailOrderFiles from "./RetailOrderFiles";

export default function ChangeOrderFiles() {

	const { order } = useContext(RetailOrderContext);
	const isCabinetOrder = order.details.roTypeID === ROType.CabinetMeasureOrder;

	return (
		<>
			{
				order.details.productLineID !== ProductLine.LaminateDelivered &&
				order.details.roTypeID !== ROType.Plumbing &&
				order.details.roTypeID !== ROType.CabinetInstallOrder &&
				<RetailOrderFiles fileTypes={
					isCabinetOrder ?
						[FileTypes.CabinetMeasureWorksheet, FileTypes.CabinetDesignPacket] : [FileTypes.PostTemplateDrawing]}
					defaultFileType={FileTypes.PostTemplateDrawing}
					buttonCaption={isCabinetOrder ? undefined : 'Upload Post Template Drawing'}
				/>
			}
		</>
	)
}